import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

// ant
import { Card, Col, Row, Spin } from 'antd'

// redux
import { RootState } from '../../reducers'
import { getUsers } from '../../reducers/users/userActions'
import { PAGINATION_USER_LIMIT } from '../../utils/enums'

// utils

// components
// types

const UsersPage = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const users = useSelector((state: RootState) => state.user.users)
	const loading = users?.isLoading

	useEffect(() => {
		dispatch(getUsers(1, PAGINATION_USER_LIMIT))
	}, [dispatch])

	const renderUserRole = (role: any) => {
		if (role === 'ADMINISTRATOR') {
			return t('loc:Admin')
		}
		return role
	}

	return (
		<>
			{loading ? (
				<Spin className={'w-full mt-20'} />
			) : (
				<div className={'flex justify-center'}>
					<div className='min-w-50 w-1/2 flex justify-between flex-wrap users' style={{ minWidth: 720 }}>
						{/* eslint-disable-next-line react/jsx-key */}
						{users.tableData.map((userTableItem) => (
							<Card className={'object-fill rounded-lg bg-gray-25 user mb-5 flex'}>
								<Row>
									<Col span={24}>
										<div className={'flex justify-between my-1 items-baseline'}>
											<div className={'mr-2'}>
												<span className={'text-gray-900 text-2xl font-normal'}>{userTableItem.firstName}</span>
												<span className={'text-gray-900 text-2xl font-bold'}> {userTableItem.lastName}</span>
											</div>
											<span className={'text-gray-700 text-xs font-semibold bg-gray-100 rounded-sm leading-none user-role rounded p-1'}>
												{renderUserRole(userTableItem?.role) || userTableItem.role}
											</span>
										</div>
									</Col>
									<Col span={24}>
										<span className={'text-gray-700 text-base font-regular'}>{userTableItem.email || '-'}</span>
									</Col>
								</Row>
								<Row className={'mt-3'}>
									<Col span={24}>
										<span className={'text-gray-500 text-base font-regular'}>Last active</span>
									</Col>
									<Col span={24}>
										<div>
											<span className={'text-gray-700 text-base font-normal'}>{userTableItem.lastLoginAtDate || '-'}</span>
											<span className={'text-gray-300'}> | </span>
											<span className={'text-gray-700 text-base font-normal'}>{userTableItem.lastLoginAtHours || '-'}</span>
										</div>
									</Col>
								</Row>
							</Card>
						))}
					</div>
				</div>
			)}{' '}
		</>
	)
}

export default UsersPage
